import React, { Component } from 'react'
import { Button } from '@progress/kendo-react-buttons'
import ApprovedRejectedDetalhes from './ApprovedRejectedDetalhes'
import History from './History'
import DadosEntidade from './DadosEntidade'
import services from '../../../../services'



class ApprovedRejected extends Component {

    constructor(props) {
        super(props)
        this.state = {
            tab: "detalhes",
            tabFormData: {},
            tabs: ["detalhes", "dadosEntidade", "history"],
            estatutosRes:[],

        }
        
    }

    componentDidMount() {
        this.estatutosApi()
        this.getEntityDetails(this.props.row['idEntidadeAplicacao'])
        console.log("8888888888888888", this.props.row)
    }

    estatutosApi= async ()=>{
        let Request = this.filterResponse();
        let link = "Sales/GetEstatutoListByEntityId"
        let estatutosRes = await services.apiCall.requestApi(link,Request);

        this.setState({
            estatutosRes,
        })
       
    }

    filterResponse=()=>{
        let Request={
            "Filters": null,
            "SortBy": "",
            "IsSortTypeDESC": true,
            "IsPagination": true,
            "Page": 1,
            "PageSize": 10,
        }
        let {idEntidadeAplicacao} = this.props.row;
        Request["entityId"]=idEntidadeAplicacao;

        return Request;
    }

    getEntityDetails = async (entity_id) => {
        try {
            let Request = {};
            Request.entityId = parseInt(entity_id);
            let link = "/Revenue/GetEntityDetail";
            let entityDetail={}
            let entityDetailResponse = await services.apiCall.requestApi(link, Request);
            //console.log("hello hi some thing");
            //console.log(res);
            if (entityDetailResponse) {
                console.log("the entity detaillllllll", entityDetailResponse)
                entityDetailResponse['v_CC_Entidade_Contact'].map(el => {
                    switch (el.codTipoContacto2) {
                        case "TLM":
                            entityDetail.telephone = el.contacto
                            break;
                        
                        case "EMAIL":
                            entityDetail.email = el.contacto
                            break;
                    
                        default:
                            break;
                    }
                    // if(el.codTipoContacto2 === "TLM"){
                    //     entityDetail.telephone = el.contacto
                    // }
                    // else if(el.codTipoContacto2 === "EMAIL") {
                    //     entityDetail.email = el.contacto
                    // }
                })
                
                this.setState({
                    entityDetail
                })
                console.log("usefullllll responseeeee ", this.state.entityDetail)
            }
        } catch (error) {
            this.setState({error})
        }
    }

    componentDidUpdate(prevProps) {
        // console.log("prev", prevProps.handledef, this.props.handledef)
        
        if (prevProps.handledef != this.props.handledef) {
            this.estatutosApi()
            this.getEntityDetails(this.props.row['idEntidadeAplicacao'])
            this.setState({ tab: "detalhes" })
            console.log("8888888888888888", this.props.row)
        }
    }


    updateTabOnly = (tab) => {
        this.setState({
            tab
        })
    }

    render() {

        let { tab, tabs } = this.state
        return (
            <div className="modal-content">
                <div className="modal-header">
                    <span className="modal-title bold" style={{ fontSize: "large" }}>
                        <b>Detalhe do pedido</b>
                    </span>
                    <Button primary={true} className="remove btn-ivdp-primary cursor-pointer mr-2" data-dismiss="modal">Fechar</Button>
                </div>
                <div className="modal-body right-tab">
                    <ul className="nav nav-tabs d-flex text-center">
                        <li className="nav-item flex-fill">
                            <strong><a className={`nav-link selos-nav ${tab==tabs[0]?`active`:""}`} onClick={() => this.updateTabOnly('detalhes')} data-toggle="tab" href="#Detalhes">Detalhes</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                             <strong><a className={`nav-link selos-nav ${tab==tabs[1]?`active`:""}`} onClick={() => this.updateTabOnly('dadosEntidade')} data-toggle="tab" href="#Dados entidade">Dados entidade</a></strong>
                        </li>
                        <li className="nav-item flex-fill">
                             <strong><a className={`nav-link selos-nav ${tab==tabs[2]?`active`:""}`} onClick={() => this.updateTabOnly('history')} data-toggle="tab" href="#Histórico">Histórico</a></strong>
                        </li>
                    </ul>

                    {/*Rendering one of the component at a time*/}
                    {tab == tabs[0] && <ApprovedRejectedDetalhes pedidos={this.props.pedidos} row={this.props.row} />}
                    {tab == tabs[1] && <DadosEntidade row={this.props.row} entityDetail={this.state.entityDetail} estatutosRes={this.state.estatutosRes}/>}
                    {tab == tabs[2] && <History pedidos={this.props.pedidos} row={this.props.row}/>}
                    {/*this.setState({ tab: "detalhes"})*/}


                </div>
            </div>
        )
    }
}
export default ApprovedRejected;